import ReactDOM from 'react-dom/client';
import App from './app/App.jsx';
import { publicUrl } from './app/publicUrl.js';
import { applyDocumentLocale, resolveUiLocale } from './i18n/locale.js';
import { installLobbyDebugBridge } from './p2p/lobbyDebug.js';
import './ui/tokens.css';
import './ui/app.css';

applyDocumentLocale(resolveUiLocale());
installLobbyDebugBridge();

ReactDOM.createRoot(document.getElementById('root')).render(
  <App />
);

if ('serviceWorker' in navigator && import.meta.env.PROD) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(publicUrl('sw.js'))
      .then((registration) => registration.update())
      .catch(() => {});
  });
}
